import * as React from "react";

const EggSvgIcon = ({ size = 12, ...props }) => {
  const rectRx = size / 4;
  const rectStrokeWidth = size / 15;

  const scalePath = (path, size) => {
    return path.replace(/(\d+(\.\d+)?)/g, (match) => {
      return `${(parseFloat(match) * (size / 12)).toFixed(5)}`;
    });
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Outer Rectangle */}
      <rect
        x={size / 40}
        y={size / 40}
        width={size - size / 20}
        height={size - size / 20}
        rx={rectRx}
        fill="white"
      />
      <rect
        x={size / 40}
        y={size / 40}
        width={size - size / 20}
        height={size - size / 20}
        rx={rectRx}
        stroke="#E59770"
        strokeWidth={rectStrokeWidth}
      />
      <mask
        id="path-2-outside-1"
        maskUnits="userSpaceOnUse"
        x={2.1875 * (size / 12)}
        y={1.25 * (size / 12)}
        width={8 * (size / 12)}
        height={10 * (size / 12)}
        fill="black"
      >
        <rect
          fill="white"
          x={2.1875 * (size / 12)}
          y={1.25 * (size / 12)}
          width={8 * (size / 12)}
          height={10 * (size / 12)}
        />
        <path
          d={`M${6 * (size / 12)} ${2.25 * (size / 12)}C${
            5.28889 * (size / 12)
          } ${2.25001 * (size / 12)} ${6.71109 * (size / 12)} ${
            2.25001 * (size / 12)
          } ${6 * (size / 12)} ${2.25 * (size / 12)}C${8.23882 * (size / 12)} ${
            2.24998 * (size / 12)
          } ${9.75756 * (size / 12)} ${6.83373 * (size / 12)} ${
            8.13322 * (size / 12)
          } ${8.70663 * (size / 12)}C${6.9267 * (size / 12)} ${
            10.0978 * (size / 12)
          } ${5.0733 * (size / 12)} ${10.0978 * (size / 12)} ${
            3.86678 * (size / 12)
          } ${8.70663 * (size / 12)}C${2.24244 * (size / 12)} ${
            6.83373 * (size / 12)
          } ${3.76118 * (size / 12)} ${2.24998 * (size / 12)} ${
            6 * (size / 12)
          } ${2.25 * (size / 12)}Z`}
        />
      </mask>
      <path
        d={`M${6 * (size / 12)} ${2.25 * (size / 12)}C${
          5.28889 * (size / 12)
        } ${2.25001 * (size / 12)} ${6.71109 * (size / 12)} ${
          2.25001 * (size / 12)
        } ${6 * (size / 12)} ${2.25 * (size / 12)}C${8.23882 * (size / 12)} ${
          2.24998 * (size / 12)
        } ${9.75756 * (size / 12)} ${6.83373 * (size / 12)} ${
          8.13322 * (size / 12)
        } ${8.70663 * (size / 12)}C${6.9267 * (size / 12)} ${
          10.0978 * (size / 12)
        } ${5.0733 * (size / 12)} ${10.0978 * (size / 12)} ${
          3.86678 * (size / 12)
        } ${8.70663 * (size / 12)}C${2.24244 * (size / 12)} ${
          6.83373 * (size / 12)
        } ${3.76118 * (size / 12)} ${2.24998 * (size / 12)} ${
          6 * (size / 12)
        } ${2.25 * (size / 12)}Z`}
        fill="#F9E8D4"
      />
      <path
        d={scalePath("M8.13322 8.70663L8.63686 9.14343L8.13322 8.70663ZM3.86678 8.70663L4.37042 8.26984L3.86678 8.70663ZM5.99999 2.91667C6.08888 2.91667 6.14443 2.91667 6.17498 2.91667C6.19026 2.91667 6.19927 2.91667 6.20307 2.91667C6.20403 2.91667 6.20462 2.91667 6.20489 2.91667C6.20496 2.91667 6.20498 2.91667 6.20496 2.91667C6.20495 2.91667 6.20486 2.91667 6.20481 2.91667C6.20466 2.91667 6.20356 2.91667 6.2026 2.91666C5.53861 2.24953 6.20408 1.58334 6.20461 1.58334C6.20473 1.58334 6.2049 1.58334 6.20494 1.58334C6.20498 1.58334 6.205 1.58334 6.20493 1.58334C6.20444 1.58334 6.20277 1.58334 6.19997 1.58334C6.17776 1.58334 6.08889 1.58334 5.99999 1.58334C5.9111 1.58334 5.82223 1.58334 5.80002 1.58334C5.79722 1.58334 5.79555 1.58334 5.79506 1.58334C5.795 1.58334 5.79501 1.58334 5.79506 1.58334C5.79509 1.58334 5.79526 1.58334 5.79538 1.58334C5.79592 1.58334 6.46138 2.24956 5.79736 2.91666C5.79642 2.91667 5.79532 2.91667 5.79518 2.91667C5.79513 2.91667 5.79504 2.91667 5.79503 2.91667C5.79501 2.91667 5.79503 2.91667 5.7951 2.91667C5.79537 2.91667 5.79596 2.91667 5.79692 2.91667C5.80072 2.91667 5.80973 2.91667 5.82501 2.91667C5.85557 2.91667 5.91112 2.91667 6.00001 2.91667L5.99999 1.58333C5.91111 1.58333 5.85555 1.58333 5.82499 1.58334C5.80971 1.58334 5.80067 1.58334 5.79683 1.58334C5.79588 1.58334 5.79521 1.58334 5.79484 1.58334C5.79475 1.58334 5.79465 1.58334 5.79455 1.58334C5.79449 1.58334 5.79438 1.58334 5.7943 1.58334C5.79413 1.58334 5.79303 1.58334 5.79208 1.58334C5.12805 2.25045 5.79352 2.91667 5.79407 2.91667C5.79421 2.91667 5.7944 2.91667 5.79447 2.91667C5.79459 2.91667 5.79471 2.91667 5.79478 2.91667C5.79542 2.91667 5.79723 2.91667 5.79997 2.91667C5.82221 2.91667 5.91111 2.91667 5.99999 2.91667C6.08887 2.91667 6.17778 2.91667 6.20001 2.91667C6.20276 2.91667 6.20457 2.91667 6.2052 2.91667C6.20528 2.91667 6.2054 2.91667 6.20551 2.91667C6.20559 2.91667 6.20578 2.91667 6.20591 2.91667C6.20646 2.91667 6.87194 2.25047 6.20794 1.58334C6.20698 1.58334 6.20586 1.58334 6.20569 1.58334C6.20562 1.58334 6.2055 1.58334 6.20544 1.58334C6.20534 1.58334 6.20524 1.58334 6.20515 1.58334C6.20478 1.58334 6.20411 1.58334 6.20316 1.58334C6.19932 1.58334 6.19028 1.58334 6.17501 1.58334C6.14445 1.58334 6.08889 1.58333 6.00001 1.58333L5.99999 2.91667ZM6.00001 2.91667C6.31835 2.91666 6.66913 3.07862 7.02069 3.45229C7.37157 3.82523 7.67726 4.3653 7.88236 4.98534C8.08673 5.60317 8.17897 6.26379 8.13514 6.85867C8.09104 7.45732 7.91386 7.94206 7.62958 8.26984L8.63686 9.14343C9.16475 8.53476 9.40686 7.74418 9.46487 6.95663C9.52317 6.1653 9.40036 5.32882 9.14823 4.56661C8.89683 3.80659 8.50458 3.08367 7.99179 2.53864C7.47968 1.99434 6.80106 1.58333 5.99999 1.58333L6.00001 2.91667ZM7.62958 8.26984C7.1403 8.83399 6.55322 9.08333 6 9.08333C5.44678 9.08333 4.8597 8.83399 4.37042 8.26984L3.36314 9.14343C4.08038 9.97043 5.02325 10.4167 6 10.4167C6.97675 10.4167 7.91962 9.97043 8.63686 9.14343L7.62958 8.26984ZM4.37042 8.26984C4.08614 7.94206 3.90896 7.45732 3.86486 6.85867C3.82103 6.26379 3.91327 5.60317 4.11764 4.98533C4.32274 4.3653 4.62843 3.82523 4.97931 3.45229C5.33087 3.07862 5.68165 2.91666 5.99999 2.91667L6.00001 1.58333C5.19894 1.58333 4.52032 1.99433 4.00821 2.53864C3.49542 3.08367 3.10317 3.80659 2.85177 4.5666C2.59964 5.32882 2.47683 6.1653 2.53513 6.95663C2.59314 7.74418 2.83525 8.53476 3.36314 9.14343L4.37042 8.26984Z",size)}
        fill="#E59770"
      />
      <circle cx={6 * (size / 12)} cy={6.9375* (size / 12)} r={1.875* (size / 12)} fill="#FEC007" />
      <ellipse
        cx={5.08605* (size / 12)}
        cy={6.03325* (size / 12)}
        rx={0.46875* (size / 12)}
        ry={0.234375* (size / 12)}
        transform="rotate(-45 5.08605 6.03325)"
        fill="#FFFCF6"
      />
    </svg>
  );
};

export default EggSvgIcon;
